import * as yup from "yup"

export const OrderClone = yup.object({
  origen_id: yup.string().required("Este campo es obligatorio").nullable(),
  destino_id: yup.string().required("Este campo es obligatorio").nullable(),  
  observacion_ventas: yup.string().required("Este campo es obligatorio"),
  
})
